import { useEffect } from 'react';
import { useUser } from '../contexts/UserContext';

const API_BASE = process.env.REACT_APP_API_BASE;

export const AuthInitialize = () => {
  const { setUser, clearUser, setUserLoading, setUserErrorState } = useUser();

  useEffect(() => {
    const initializeAuth = async () => {
      setUserLoading(true);
      setUserErrorState(null);

      try {
        const response = await fetch(`${API_BASE}/users/me`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });

        if (response.status === 401) {
          console.log('User not authorized');
          clearUser();
          setUserLoading(false);
          return;
        }

        if (!response.ok) {
          throw new Error(`Ошибка при загрузке профиля: ${response.status}`);
        }

        const userData = await response.json();
        console.log('User data loaded successfully');
        setUser(userData);
        setUserLoading(false);
      } catch (error) {
        console.error('Auth initialization error:', error);
        setUserErrorState(error.message);
        clearUser();
        setUserLoading(false);
      }
    };

    initializeAuth();
  }, [clearUser, setUser, setUserLoading, setUserErrorState]);

  return null;
};